
<template>
</template>

<script>
export default {
  name: "home",
  data() {
    return {

    };
  },
  mounted() {

  },
  methods: {

  }
};

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/index.vue


// WEBPACK FOOTER //
// src/pages/index.vue